import React from 'react';
import { IIllustrationProps } from './type';

interface IArrowDoodleProps extends IIllustrationProps {
  flipVertically?: boolean;
  flipHorizontally?: boolean;
  color?: string;
}

const ArrowDoodle: React.FC<IArrowDoodleProps> = ({
  width = 30,
  height = 16,
  color = '#000',
  flipVertically = false,
  flipHorizontally = false,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 30 16"
      fill="none"
      style={{
        transform: `scale(${flipVertically ? '-1' : '1'}, ${
          flipHorizontally ? '-1' : '1'
        })`,
      }}
      className={UNSAFE_className || ''}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.84443 2.06002C5.84555 7.93693 13.5716 10.4277 21.0499 10.9697C23.4103 11.1273 25.7781 11.1439 28.1405 11.0195C29.1033 10.9742 29.058 9.47576 28.0923 9.52112C20.553 9.87527 12.6409 9.10919 6.20523 4.82204C4.58836 3.74405 3.12925 2.44644 1.86985 0.966488C1.72429 0.831634 1.53144 0.759585 1.33312 0.765959C1.13479 0.772334 0.94697 0.856619 0.810369 1.00054C0.678754 1.14765 0.60886 1.33981 0.615201 1.5371C0.621543 1.7344 0.703639 1.92167 0.84443 2.06002Z"
        fill={color}
      />
      <path
        d="M24.5562 6.73594C25.8111 8.03399 27.2099 9.18477 28.7255 10.166L28.4237 9.14965C27.6749 10.9941 26.4075 12.582 24.7749 13.721C23.984 14.2678 24.776 15.5413 25.5727 14.9904C27.4265 13.7183 28.874 11.9384 29.7418 9.86429C29.8296 9.68817 29.8472 9.4853 29.7912 9.29666C29.7352 9.10802 29.6098 8.94765 29.4401 8.84793C28.0364 7.92946 26.7418 6.85402 25.5816 5.6424C24.9112 4.94581 23.8884 6.0421 24.5562 6.73594Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowDoodle;
